export default __webpack_public_path__ + "static/media/home_library.03813612.jpg";